import { createAppVersionCheckStore } from '@thyme/libs/src/version/checkNewVersion'

export const useAppVersionChecker = createAppVersionCheckStore(APP_VERSION)
